export default "<app-left-panel></app-left-panel>\n\n<div class=\"right-panel\">\n    <router-outlet></router-outlet>\n</div>"